// app/javascript/projects/components/DemographicsView.jsx

import React from 'react';
import { useTranscriptDescriptors } from 'hooks/descriptors/queries';
import PageLoadingComponent from './PageLoadingComponent';
import useDefaultErrorToast from 'hooks/useDefaultErrorToast';
import EditDemographicView from './EditDemographicView';
import ViewOnlyDemographicView from './ViewOnlyDemographicView';

const DemographicsView = (props) => {
  const { projectID, transcriptID, hasEditPermission } = props;

  // Get descriptors with selections
  const { 
    descriptors, 
    isLoading,
    error 
  } = useTranscriptDescriptors(transcriptID, projectID);
  
  // Show error toast if loading fails
  useDefaultErrorToast(error);
  
  // Show loading state
  if (isLoading) {
    return <PageLoadingComponent />;
  }
  
  // If there's an error, return null (toast will show the error)
  if (error) {
    return null;
  }

  // Render appropriate view based on permissions
  if (hasEditPermission) {
    return (
      <EditDemographicView
        descriptors={descriptors || []}
        projectID={projectID}
        transcriptID={transcriptID}
      />
    );
  } else {
    return (
      <ViewOnlyDemographicView
        descriptors={descriptors || []}
        projectID={projectID}
        transcriptID={transcriptID}
      />
    );
  }
};

export default DemographicsView;
